import React from "react";

import { dFlex, flex1 } from "./styles";
import Paper from "./Paper";
import { panelHeaderStyle } from "./OnePanel";

const OnePanelPlus = ({ title, children }) => (
  <div style={dFlex}>
    <Paper style={{ ...flex1, marginRight: "20px" }}>
      <h1 style={{ ...panelHeaderStyle, marginBottom: "3em" }}>{title}</h1>
      {children[0]}
    </Paper>
    <div style={flex1}>{children[1]}</div>
  </div>
);

export default OnePanelPlus;



// WEBPACK FOOTER //
// ./src/components/analysis/OnePanelPlus.js